// extracted by mini-css-extract-plugin
export var moreSalesListInCartModal = "CartRecommendations-module--moreSalesListInCartModal--3cc5f";